<template>
    <div class="row">
        <div class="col-12 col-lg-9 pr-lg-0">
            <div v-if="error_status===true">
                <mdb-jumbotron class="mb-0 text-center" >
                    <h2 class="card-title h2">İşlem Sırasında Bir Hata Oluştu</h2>
                    <mdb-row class="d-flex justify-content-center">
                        <mdb-col xl="7" class="pb-2">
                            <mdb-alert color="danger">
                                <p class="card-text"><mdb-icon icon="exclamation" /> {{message}}</p>
                            </mdb-alert>
                        </mdb-col>
                    </mdb-row>
                    <hr class="my-4">
                    <mdb-btn tag="a" @click="$router.go(-1)" outline="primary" icon="arrow-left" darkWaves>Arama Sayfasına Geri Dön</mdb-btn>
                    <mdb-btn tag="a" href="/" color="blue" icon="home" >Ana Sayfa</mdb-btn>
                </mdb-jumbotron>
            </div>
            <div v-else>
                <div v-if="allocateCharter!==''">
                    <section class="" id="fly-info">
                        <mdb-card class="rez-card" >
                            <div class="row p-3">
                                <div class="col-6 col-md-4">
                                    <h2>{{fromCity}}</h2>
                                    <span class=""><b>Gidiş:</b> {{ fromDate | moment("Do MMMM YYYY, dddd ") }}
                            {{allocateCharter.departure_hour}}</span>
                                </div>
                                <div class="col-1 d-none d-md-block"><img src="../assets/images/exchange-icon.png" style="width:24px;cursor: pointer" /></div>
                                <div class="col-6 col-md-4">
                                    <h2>{{toCity}}</h2>
                                    <span class="" v-if="toDate!=='null'"><b>Dönüş:</b> {{ toDate | moment("Do MMMM YYYY, dddd ") }}
                            {{allocateCharter.arrival_hour}}</span>
                                </div>
                                <div class="col-12 col-md-3 text-right mt-3 mt-md-0 pl-0 d-none d-sm-block">
                                    <p class=" text-orange">{{adult}} Yetişkin {{child>0?"- "+child+" Çocuk":""}} {{infant>0?" -"+infant+" Bebek":""}}</p>
                                    <h2 class="text-red"><b>{{totalFare}} ₺</b></h2>
                                </div>
                            </div>
                        </mdb-card>
                    </section>
                    <section id="reservation-flight-info" class="reservation-flight pt-2">
                        <div class="bg-blue p-2">
                            <h6>Uçuş Bilgileri </h6>
                        </div>
                        <mdb-card class="reservation-card">
                            <mdb-card-body>
                                <div class="title">GİDİŞ</div>
                                <div >
                                    <div  class="mb-2 pb-2 ">
                                        <div class="flight-info">
                                            <div class="row">
                                                <div class="col-2 col-md-1">
                                                    {{allocateCharter.airline_code}}
                                                </div>
                                                <div class="col-10 col-md-11">
                                                    <span class="flight-name d-block d-md-inline-block">{{allocateCharter.airline_name}} </span>
                                                    <span class="flight-air-code">  </span>
                                                    <span class="flight-class">  </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-1 d-none d-md-block d-lg-block text-right">
                                                <mdb-icon icon="plane-departure" size="2x" />
                                            </div>
                                            <div class="col-6 col-md-3 p-md-0">
                                                <div class="hour"> {{allocateCharter.departure_hour}} {{allocateCharter.from_code}}</div>
                                                <div class="airport-name">{{allocateCharter.departure_date | moment("Do MMMM YYYY, dddd ")}}</div>
                                                <div class="airport-name">{{allocateCharter.from_name}}</div>
                                            </div>
                                            <div class="col-4 d-none d-md-block d-lg-block pl-0 text-center">
                                                <div class="flight-time">{{allocateCharter.duration.split(".")[0]}}sa {{allocateCharter.duration.split(".")[1]}}dk</div>
                                                <div class="flight-type-icon"><img src="../assets/images/aktarma.png"></div>
                                                <div class="flight-type d-none">{{allocateCharter.length>1?'Aktarmalı':'Direkt'}}</div>
                                                <div class="flight-air-code d-none">({{allocateCharter.from_code}} - {{allocateCharter.to_code}})</div>
                                            </div>
                                            <div class="col-1 d-none d-md-block d-lg-block text-right">
                                                <mdb-icon icon="plane-arrival" size="2x" />
                                            </div>
                                            <div class="col-6 col-md-3 pl-0">
                                                <div class="hour">{{allocateCharter.arrival_hour}} {{allocateCharter.to_code}}</div>
                                                <div class="airport-name">{{allocateCharter.arrival_day | moment("Do MMMM YYYY, dddd ")}}</div>
                                                <div class="airport-name">{{allocateCharter.to_name}}</div>
                                            </div>
                                            <div class="col-12 d-block d-md-none d-lg-none mt-3">
                                                <div class="flight-time">{{allocateCharter.duration.split(".")[0]}}sa {{allocateCharter.duration.split(".")[1]}}dk</div>
                                                <div class="flight-type-icon d-none"><img src="../assets/images/aktarma.png"></div>
                                                <div class="flight-type d-none">{{allocateCharter.length>1?'Aktarmalı':'Direkt'}}</div>
                                                <div class="flight-air-code d-none">({{allocateCharter.from_code}} - {{allocateCharter.to_code}})</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mdb-card-body>
                            <hr />
                            <mdb-card-body v-if="toDate!=='null'">
                                <div class="title">DÖNÜŞ</div>
                                <div >
                                    <div  class="mb-2 pb-2 ">
                                        <div class="flight-info">
                                            <div class="row">
                                                <div class="col-2 col-md-1">
                                                    {{allocateCharterArrival.airline_code}}
                                                </div>
                                                <div class="col-10 col-md-11">
                                                    <span class="flight-name d-block d-md-inline-block">{{allocateCharterArrival.airline_name}} </span>
                                                    <span class="flight-air-code">  </span>
                                                    <span class="flight-class">  </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-1 d-none d-md-block d-lg-block text-right">
                                                <mdb-icon icon="plane-departure" size="2x" />
                                            </div>
                                            <div class="col-6 col-md-3 p-md-0">
                                                <div class="hour"> {{allocateCharterArrival.departure_hour}} {{allocateCharterArrival.from_code}}</div>
                                                <div class="airport-name">{{allocateCharterArrival.from_name}}</div>
                                            </div>
                                            <div class="col-4 d-none d-md-block d-lg-block pl-0 text-center">
                                                <div class="flight-time">{{allocateCharterArrival.duration.split(".")[0]}}sa {{allocateCharterArrival.duration.split(".")[1]}}dk</div>
                                                <div class="flight-type-icon"><img src="../assets/images/aktarma.png"></div>
                                                <div class="flight-type d-none">{{allocateCharterArrival.length>1?'Aktarmalı':'Direkt'}}</div>
                                                <div class="flight-air-code d-none">({{allocateCharterArrival.from_code}} - {{allocateCharterArrival.to_code}})</div>
                                            </div>
                                            <div class="col-1 d-none d-md-block d-lg-block text-right">
                                                <mdb-icon icon="plane-arrival" size="2x" />
                                            </div>
                                            <div class="col-6 col-md-3 pl-0">
                                                <div class="hour">{{allocateCharterArrival.arrival_hour}} {{allocateCharterArrival.to_code}}</div>
                                                <div class="airport-name">{{allocateCharterArrival.to_name}}</div>
                                            </div>
                                            <div class="col-12 d-block d-md-none d-lg-none mt-3">
                                                <div class="flight-time">{{allocateCharterArrival.duration.split(".")[0]}}sa {{allocateCharterArrival.duration.split(".")[1]}}dk</div>
                                                <div class="flight-type-icon d-none"><img src="../assets/images/aktarma.png"></div>
                                                <div class="flight-type d-none">{{allocateCharterArrival.length>1?'Aktarmalı':'Direkt'}}</div>
                                                <div class="flight-air-code d-none">({{allocateCharterArrival.from_code}} - {{allocateCharterArrival.to_code}})</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </section>
                    <section id="reservation-person-info" class="reservation-flight pt-2">
                        <div class="bg-middle-orange p-2">
                            <h6>Yolcu Bilgileri</h6>
                        </div>
                        <div class="">
                            <mdb-card>
                                <mdb-card-body class="p-sm-0">
                                    <div class="col-12">
                                        <div v-if="alert_info.first_name || alert_info.last_name || alert_info.citizen_no || alert_info.birth_date || alert_info.birth_month" class="alert alert-danger mt-2">
                                            <h5><mdb-icon icon="exclamation" /> Lütfen gerekli alanları doldurunuz.</h5>
                                            <small v-if="alert_info.gender">Lütfen Cinsiyet alanını doldurunuz.<br/></small>
                                            <small v-if="alert_info.first_name">Lütfen Ad alanını doldurunuz.<br/></small>
                                            <small v-if="alert_info.last_name">Lütfen Soyad alanını doldurunuz.<br/></small>
                                            <small v-if="alert_info.citizen_no">Lütfen T.C Kimlik alanını doldurunuz.<br/></small>
                                            <small v-if="alert_info.birth_date || alert_info.birth_month">Lütfen Doğum tarihi alanını doldurunuz.<br/></small>
                                        </div>
                                        <div class="d-none">
                                            {{numitems = 0}}
                                        </div>
                                        <div class="row" v-for="index in parseInt(adult)" :key="index" :class="{'odd': index % 2 === 0, 'even': index % 2 !== 0 }">
                                            <div class="col-12 col-md-2">
                                                <label class="text-muted">{{index}} Yetişkin Yolcu</label>
                                                <!-- Group of default radios - option 1 -->
                                                <span style="display: none"> {{persons[(index-1)]['type'] = 'ADT'}}</span>
                                                <input type="hidden" :name="'type'+index" v-model="persons[(index-1)]['type']">
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" class="custom-control-input" :id="'male'+index" :name="'gender'+index" v-model="persons[(index-1)]['gender']" value="M">
                                                    <label class="custom-control-label" :for="'male'+index">Erkek</label>
                                                </div>

                                                <!-- Group of default radios - option 2 -->
                                                <div class="custom-control custom-radio">
                                                    <input ref="first_name" type="radio" class="custom-control-input" :id="'female'+index" :name="'gender'+index"
                                                           v-model="persons[(index-1)]['gender']" value="F">
                                                    <label class="custom-control-label" :for="'female'+index">Kadın</label>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-3 pr-md-1">
                                                <div class="form-group">
                                                    <label :for="'name'+index">Ad *</label>
                                                    <input type="text" :id="'name'+index" class="form-control" name="first_name[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['first_name']" :class="{'is-invalid':hasError == 'name'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Ad giriniz</div>
                                                </div>
                                                <div class="form-group">
                                                    <input type="text" class="form-control form-control-sm" placeholder="Miles And Smiles no"
                                                           v-model="persons[(index-1)]['miles_id']">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-3 pl-md-2">
                                                <div class="form-group">
                                                    <label :for="'surename'+index">Soyad *</label>
                                                    <input type="text" :id="'surename'+index" class="form-control" name="last_name[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['last_name']" :class="{'is-invalid':hasError == 'surename'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Soyad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-2 pl-md-0">
                                                <div class="form-group" v-if="(toCountry==='TR' && fromCountry == 'TR')">
                                                    <label :for="'tcno'+index">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+index" class="form-control" name="citizen_no[]" @blur="handleBlur" maxlength="11" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['citizen_no']" :class="{'is-invalid':hasError == 'tcno'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                                <div class="form-group" v-else>
                                                    <label :for="'ppno'+index">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+index" class="form-control" name="passport_no[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['passport_no']" :class="{'is-invalid':hasError == 'ppno'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[(index-1)]['passport_country']">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-2 pl-md-0">
                                                <div class="form-group">
                                                    <label :for="'birthdate'+index">Doğum Tarihi *</label>
                                                    <input type="text" :id="'birthdate'+index" class="form-control" name="birth_date[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'birthdate'+index || hasError=='All'}"
                                                           v-model="persons[(index-1)]['birth_datef']" v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Doğum tarihini doğru formatta giriniz</div>
                                                    <!--<datepicker :readonly=false class="form-control" name="birth_date[]" v-model="persons[(index-1)]['birth_date']"
                                                                :format="customFormatter" :language="tr" :disabledDates="disabledAdultDates" :initialView="'year'"
                                                    ></datepicker>-->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row" v-if="child>0" v-for="indexchd in parseInt(child)" :key="indexchd" :class="{'odd': indexchd % 2 === 0, 'even': indexchd % 2 !== 0 }">
                                            <div class="col-12 col-md-2">
                                                <label class="text-muted">{{indexchd}} Çocuk Yolcu</label>
                                                <!-- Group of default radios - option 1 -->
                                                <span style="display: none"> {{persons[((parseInt(adult)+indexchd)-1)]['type'] = 'CHD'}}</span>

                                                <input type="hidden" :name="'type'+(parseInt(adult)+indexchd)" v-model="persons[((parseInt(adult)+indexchd)-1)]['type']">
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" class="custom-control-input" :id="'male'+(parseInt(adult)+indexchd)"
                                                           :name="'gender'+(parseInt(adult)+indexchd)" v-model="persons[((parseInt(adult)+indexchd)-1)]['gender']" value="M">
                                                    <label class="custom-control-label" :for="'male'+(parseInt(adult)+indexchd)">Erkek</label>
                                                </div>

                                                <!-- Group of default radios - option 2 -->
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" class="custom-control-input" :id="'female'+(parseInt(adult)+indexchd)"
                                                           :name="'gender'+(parseInt(adult)+indexchd)" v-model="persons[(parseInt(adult)+indexchd-1)]['gender']" value="F">
                                                    <label class="custom-control-label" :for="'female'+(parseInt(adult)+indexchd)">Kadın</label>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-3 pr-md-1">
                                                <div class="form-group">
                                                    <label :for="'name'+(parseInt(adult)+indexchd)">Ad *</label>
                                                    <input type="text" :id="'name'+(parseInt(adult)+indexchd)" class="form-control" name="first_name[]" @blur="handleBlur"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['first_name']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'name'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Ad giriniz</div>
                                                </div>
                                                <div class="form-group">
                                                    <input type="text" class="form-control form-control-sm" placeholder="Miles And Smiles no"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['miles_id']">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-3 pl-md-2">
                                                <div class="form-group">
                                                    <label :for="'surename'+(parseInt(adult)+indexchd)">Soyad *</label>
                                                    <input type="text" :id="'surename'+(parseInt(adult)+indexchd)" class="form-control" name="last_name[]" @blur="handleBlur"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['last_name']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'surename'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Soyad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-2 pl-md-0">
                                                <div class="form-group" v-if="(toCountry==='TR' && fromCountry == 'TR')">
                                                    <label :for="'tcno'+(parseInt(adult)+indexchd)">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+(parseInt(adult)+indexchd)" class="form-control"
                                                           name="citizen_no[]" @blur="handleBlur" maxlength="11" :tabindex="numitems +=1"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['citizen_no']"
                                                           :class="{'is-invalid':hasError == 'tcno'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                                <div class="form-group" v-else>
                                                    <label :for="'ppno'+(parseInt(adult)+indexchd)">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+(parseInt(adult)+indexchd)" class="form-control" :tabindex="numitems +=1"
                                                           name="passport_no[]" @blur="handleBlur" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_no']"
                                                           :class="{'is-invalid':hasError == 'ppno'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_country']">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-2 pl-md-0">
                                                <div class="form-group">
                                                    <label :for="'birthdate'+(parseInt(adult)+indexchd)">Doğum Tarihi *</label>
                                                    <input type="text" :id="'birthdate'+(parseInt(adult)+indexchd)" class="form-control" @blur="handleBlur"
                                                           name="birth_date[]" v-model="persons[(parseInt(adult)+indexchd-1)]['birth_datef']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'birthdate'+(parseInt(adult)+indexchd) || hasError=='All'}"
                                                           v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Doğum tarihini doğru formatta giriniz</div>
                                                    <!--datepicker class="form-control" name="birth_date[]" v-model="persons[(parseInt(adult)+indexchd-1)]['birth_date']"
                                                                :format="customFormatter" :language="tr" :disabledDates="disabledChildDates" :initialView="'year'"
                                                    ></datepicker-->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row" v-if="infant>0" v-for="indexinf in parseInt(infant)" :key="indexinf" :class="{'odd': indexinf % 2 === 0, 'even': indexinf % 2 !== 0 }">
                                            <div class="col-12 col-md-2">
                                                <label class="text-muted">{{indexinf}}. Bebek Yolcu</label>
                                                <!-- Group of default radios - option 1 -->
                                                <span style="display: none"> {{persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['type'] = 'INF'}}</span>

                                                <input type="hidden" :name="'type'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                       v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['type']">
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" class="custom-control-input" :id="'male'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                           name="gender[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['gender']" value="M">
                                                    <label class="custom-control-label" :for="'male'+(parseInt(adult)+parseInt(child)+indexinf)">Erkek</label>
                                                </div>

                                                <!-- Group of default radios - option 2 -->
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" class="custom-control-input" :id="'female'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                           name="gender[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['gender']" value="F">
                                                    <label class="custom-control-label" :for="'female'+(parseInt(adult)+parseInt(child)+indexinf)">Kadın</label>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-3 pr-md-1">
                                                <div class="form-group">
                                                    <label :for="'name'+(parseInt(adult)+parseInt(child)+indexinf)">Ad *</label>
                                                    <input type="text" :id="'name'+(parseInt(adult)+parseInt(child)+indexinf)" class="form-control"
                                                           @blur="handleBlur"
                                                           name="first_name[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['first_name']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'name'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Ad giriniz</div>
                                                </div>
                                                <div class="form-group">
                                                    <input type="text" class="form-control form-control-sm" placeholder="Miles And Smiles no"
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['miles_id']">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-3 pl-md-2">
                                                <div class="form-group">
                                                    <label :for="'surename'+(parseInt(adult)+parseInt(child)+indexinf)">Soyad *</label>
                                                    <input type="text" :id="'surename'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                           class="form-control" @blur="handleBlur" :tabindex="numitems +=1"
                                                           name="last_name[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['last_name']"
                                                           :class="{'is-invalid':hasError == 'surename'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Soyad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-2 pl-md-0">
                                                <div class="form-group" v-if="(toCountry==='TR' && fromCountry == 'TR')">
                                                    <label :for="'tcno'+(parseInt(adult)+parseInt(child)+indexinf)">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+(parseInt(adult)+parseInt(child)+indexinf)" :tabindex="numitems +=1"
                                                           class="form-control" @blur="handleBlur" name="citizen_no[]" maxlength="11"
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['citizen_no']"
                                                           :class="{'is-invalid':hasError == 'tcno'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                                <div class="form-group" v-else>
                                                    <label :for="'ppno'+(parseInt(adult)+parseInt(child)+indexinf)">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+(parseInt(adult)+parseInt(child)+indexinf)" class="form-control" name="passport_no[]"
                                                           @blur="handleBlur" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['passport_no']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'ppno'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['passport_country']">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-2 pl-md-0">
                                                <div class="form-group">
                                                    <label :for="'birthdate'+(parseInt(adult)+parseInt(child)+indexinf)">Doğum Tarihi *</label>
                                                    <input type="text" :id="'birthdate'+(parseInt(adult)+parseInt(child)+indexinf)" class="form-control" name="birth_date[]"
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['birth_datef']" @blur="handleBlur"
                                                           :class="{'is-invalid':hasError == 'birthdate'+(parseInt(adult)+indexinf) || hasError=='All'}" :tabindex="numitems +=1"
                                                           v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Doğum tarihini doğru formatta giriniz</div>
                                                    <!--datepicker class="form-control" name="birth_date[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['birth_date']"
                                                                :format="customFormatter" :language="tr"  :disabledDates="disabledBabeDates" :initialView="'year'"
                                                    ></datepicker-->

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </mdb-card-body>
                            </mdb-card>
                        </div>
                    </section>
                    <section id="reservation-user" class="reservation-flight pt-2">
                        <div class="bg-blue p-2">
                            <h6>İletişim Bilgileri</h6>
                        </div>
                        <div class="">
                            <mdb-card>
                                <mdb-card-body>

                                    <label class="text-red">

                                        Uçuş bilgileriniz e-postanıza ve cep telefonunuza gönderilecektir.
                                    </label>
                                    <div class="row">
                                        <div class="col-12 col-md-4 pr-md-1">
                                            <div class="form-group">
                                                <label for="email">E-Posta Adresiniz</label>
                                                <input type="email" id="email" class="form-control" v-model="contact_email"
                                                       @blur="handleBlur" :class="{'is-invalid':hasError == 'email' || hasError=='All'}" name="user_email">
                                                <div class="invalid-feedback">Lütfen E-mail adresini giriniz</div>
                                            </div>
                                        </div>
                                        <div class="col-5 col-md-2 px-md-2 pr-0">
                                            <div class="form-group">
                                                <label for="phone-code">Cep Telefonu</label>
                                                <input type="text" id="phone-code" class="form-control" readonly placeholder="+90" name="contact_phone_area" v-model="contact_phone_area" >
                                            </div>
                                        </div>
                                        <div class="col-7 col-md-3 pl-md-0">
                                            <div class="form-group">
                                                <label for="phone-number"></label>
                                                <input type="text" id="phone-number" class="form-control" required v-mask="'5## ### ## ##'"
                                                       placeholder="5__ ___ __ __" name="contact_phone" v-model="contact_phone" style="margin-top: 11px"
                                                       @blur="handleBlur" :class="{'is-invalid':hasError == 'phone-number' || hasError=='All'}" >
                                                <div class="invalid-feedback">Lütfen Cep Telefon numaranızı giriniz</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row discount-area">
                                        <div class="col-12 col-md-3 pl-md-0">
                                            <p>İndirim Kuponu Kullan:</p>
                                        </div>
                                        <div class="col-6 col-md-2 p-md-0">
                                            <div class="form-group">
                                                <input type="text" id="discount-code" class="form-control" >
                                            </div>
                                        </div>
                                        <div class="col-6 col-md-2">
                                            <button class="btn btn-biletbul-bg-blue btn-sm" >Doğrula</button>
                                        </div>
                                    </div>
                                    <div class="">
                                        <div>
                                            <label>Fırsat ve duyurulardan haberdar olmak;</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input " id="not-allow" v-model="noBulten" @click="acceptBulten = false" value="false" >
                                            <label class="custom-control-label" for="not-allow">İstemiyorum</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="allow-info" v-model="acceptBulten" @click="noBulten = false" value="true" />
                                            <label class="custom-control-label" for="allow-info">İstiyorum</label>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="fatura-want" value="true" v-model="fatura_want" @click="collapse2 === true ? collapse2 = false : collapse2 = true"/>
                                            <label class="custom-control-label" for="fatura-want"> Fatura İstiyorum</label>
                                        </div>
                                    </div>
                                    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave">
                                        <div v-if="collapse2" class="collapse-item mt-2">
                                            <div class="row m-1" style="background-color: aliceblue;padding: 10px;">
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="billing_name">Firma Ünvan/Kişi Adı soyadı </label>
                                                        <input type="text" id="billing_name" class="form-control"
                                                               name="billing_name" v-model="billing_name">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="tax_office">Vergi Dairesi </label>
                                                        <input type="text" id="tax_office" class="form-control"
                                                               name="tax_office" v-model="tax_office">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="tax_number">Vergi/TCK no </label>
                                                        <input type="text" id="tax_number" class="form-control"
                                                               name="tax_number" v-model="tax_number">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="address_detail">Adres </label>
                                                        <input type="text" id="address_detail" class="form-control"
                                                               name="address_detail" v-model="address_detail">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <label for="zip_code">Posta kodu </label>
                                                        <input type="text" id="zip_code" class="form-control"
                                                               name="zip_code" v-model="zip_code">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <label for="address_district">İlçe </label>
                                                        <input type="text" id="address_district" class="form-control"
                                                               name="address_district" v-model="address_district">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <label for="city">Şehir </label>
                                                        <input type="text" id="city" class="form-control"
                                                               name="city" v-model="city">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                    <div class="text-right" v-if="!odemeYap">
                                        <button class="btn m-0 btn-default" @click="updatePassengersCharter()" :disabled="disabledButton">Ödeme Adımına İlerle</button>
                                    </div>
                                </mdb-card-body>
                            </mdb-card>
                        </div>
                    </section>
                    <section id="reservation-payment" class="reservation-flight pt-2" v-if="odemeYap">
                        <div class="bg-blue p-2">
                            <h6>Ödeme Bilgileri</h6>
                        </div>
                        <form method="post" action="https://vpos.qnbfinansbank.com/Gateway/Default.aspx">
                        <div class="">
                            <mdb-card>
                                <mdb-card-body>
                                    <div class="row">
                                        <div class="col-12 col-md-6 pr-md-1">
                                            <div class="form-group">
                                                <label for="holder-name">Kartın Üzerindeki Ad-Soyad</label>
                                                <input type="text" id="holder-name" name="CardHolderName" class="form-control" v-model="card_holder">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-6 pr-md-1">
                                            <div class="form-group">
                                                <label for="card-number">Kart Numarası</label>
                                                <input type="text" id="card-number" v-mask="'####-####-####-####'" class="form-control" v-model="card_number">
                                                <input type="hidden" name="Pan"  :value='card_number.replace(/-/g,"")'>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <label for="card-month">Son Kullanma Tarihi</label>
                                            <div class="row">
                                                <div class="col-6 pr-1">
                                                    <div class="form-group">
                                                        <label for="card-month">Ay</label>
                                                        <input type="text" min="01" max="12" id="card-month" v-mask="'##'" class="form-control" placeholder="_ _" v-model="expiration_month">
                                                    </div>
                                                </div>
                                                <div class="col-6 pr-1">
                                                    <div class="form-group">
                                                        <label for="card-year">Yıl</label>
                                                        <input type="text" id="card-year" v-mask="'##'" class="form-control" placeholder="_ _" v-model="expiration_year">
                                                    </div>
                                                </div>
                                            </div>
                                            <input name="Expiry" type="hidden" :value="expiration_month+expiration_year" >
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <label for="card-cvv">Güvenlik Kodu</label>
                                            <div class="row">
                                                <div class="col-6 pr-1">
                                                    <div class="form-group">
                                                        <label for="card-cvv">CVV</label>
                                                        <input type="text" id="card-cvv" name="Cvv2" v-mask="'###'" class="form-control" placeholder="_ _ _" v-model="cv2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 d-none">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" class="custom-control-input" id="masterCard" name="card_type" v-model="card_type" value="Master">
                                                <label class="custom-control-label" for="masterCard">Master</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" class="custom-control-input" id="visaCard" name="card_type" v-model="card_type" value="Visa">
                                                <label class="custom-control-label" for="visaCard">Visa</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 discount-area">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input " id="payment_type" v-model="payment_type" value="1" checked disabled/>
                                            <label class="custom-control-label" for="payment_type"> 3D ile ödeme yapmak istiyorum.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 discount-area">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input " id="accept-rules" checked>
                                            <label class="custom-control-label" for="accept-rules">
                                                <a href="/#/gizlilik-sozlesmesi" target="_blank">
                                                    Acente Kuralları, Bilet Kuralları ve Kişisel Verilerin Korunması ve Gizlilik Politikası nı okudum, kabul ediyorum
                                                </a>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-4">
                                        <p style="font-size: 16px">Bu bir Charter uçuştur.
                                            Charter uçuşlarda iptal ve değişiklik yapılamaz. </p>
                                        <div class="row bg-light-gray" style="border-radius: 6px">
                                            <div class="col-12 col-md-8 pl-md-5">
                                                <span style="font-size:20px;color: black">Toplam Ödenecek Tutar:</span>
                                                <span class="total-price pl-4" style="font-size: 30px;font-weight: bold;color: black">{{totalFare}} ₺</span>
                                            </div>
                                            <div class="col-12 col-md-4 text-right pr-md-0">
                                                <button class="btn btn-lg m-0 bg-green" type="submit" >Satın Al</button>
                                            </div>
                                        </div>
                                    </div>
                                </mdb-card-body>
                            </mdb-card>
                        </div>
                            <input type="hidden" name="MbrId" :value="MbrId">
                            <input type="hidden" name="MerchantID" :value="MerchantID">
                            <input type="hidden" name="UserCode" :value="UserCode">
                            <input type="hidden" name="SecureType" :value="SecureType">
                            <input type="hidden" name="TxnType" :value="TxnType">
                            <input type="hidden" name="InstallmentCount" :value="InstallmentCount">
                            <input type="hidden" name="Currency" :value="Currency">
                            <input type="hidden" name="OkUrl" :value="OkUrl">
                            <input type="hidden" name="FailUrl" :value="FailUrl">
                            <input type="hidden" name="OrderId" :value="OrderId">
                            <input type="hidden" name="PurchAmount" :value="PurchAmount">
                            <input type="hidden" name="Lang" :value="Lang">
                            <input type="hidden" name="Rnd" :value="Rnd">
                            <input type="hidden" name="Hash" :value="Hash">
                        </form>
                    </section>
                </div>
                <div v-else>
                    <section class="mb-4" id="fly-info">
                        <mdb-card class="rez-card">
                            <div class="row p-3">
                                <div class="col-6 col-md-4">
                                    <h2>{{fromCity}}</h2>
                                    <span class=""><b>Gidiş:</b> {{ fromDate | moment("Do MMMM YYYY, dddd ") }}
                            {{allocate.segments[0].departure_time}}</span>
                                </div>
                                <div class="col-1 d-none d-md-block"><img src="../assets/images/exchange-icon-black.png" style="width:24px;cursor: pointer" /></div>
                                <div class="col-6 col-md-4">
                                    <h2>{{toCity}}</h2>
                                    <span class="" v-if="toDate!=='null'"><b>Dönüş:</b> {{ toDate | moment("Do MMMM YYYY, dddd ") }}
                            {{allocate.segments[allocate.segments.length-1].departure_time}}</span>
                                </div>
                                <div class="col-12 col-md-3 text-right mt-3 mt-md-0 pl-0 d-none d-sm-block">
                                    <p class="m-0">{{adult}} Yetişkin {{child>0?"- "+child+" Çocuk":""}} {{infant>0?" -"+infant+" Bebek":""}}</p>
                                    <h2 class="text-red"><b>{{totalFare}} ₺</b></h2>
                                </div>
                            </div>
                        </mdb-card>
                    </section>
                    <section id="reservation-flight-info" class="reservation-flight mb-4">
                        <div class="p-2 mb-4" style="background-color: #3399d4; border-radius: 6px">
                            <h3 class="text-white" style="font-weight: 300">Uçuş Bilgileri </h3>
                        </div>
                        <div class="title"><b>Gidiş</b></div>

                        <div v-for="group in sirala">
                            <div v-for="(item,index) in group" v-if="item.od_destination_code == allocate.segments[0].od_destination_code"
                                 :key="index"  class="mb-2 pb-2 ">
                                <div class="flight-info">
                                    <div class="row">
                                        <div class="col-2 col-md-1">
                                            <img :src="createFlyLogo(item.operating_airline_code)" class="fly-logo">
                                        </div>
                                        <div class="col-10 col-md-11">
                                            <span class="flight-name d-block d-md-inline-block">
                                                {{item.operating_airline_name}} {{item.flight_number}} {{flightClass}} / {{item.booking_class}}</span>

                                        </div>
                                    </div>
                                </div>
                                <div class="ucus-bilgi pl-3 pl-md-0">
                                <div class="row">
                                    <div class="col-1 d-none d-md-block d-lg-block text-right">
                                        <img src="../assets/images/Kalkis-wh.png" />

                                    </div>
                                    <div class="col-6 col-md-3 p-md-0">
                                        <div class="hour">{{item.departure_time}} {{item.origin_code}}</div>
                                        <div class="airport-name">{{item.departure_day | moment("Do MMMM YYYY, dddd ")}}</div>
                                        <div class="airport-name">{{item.origin_name}}</div>
                                    </div>
                                    <div class="col-4 d-none d-md-block d-lg-block pl-0 text-center">
                                        <div class="flight-time">{{item.duration.split(":")[0]}}sa {{item.duration.split(":")[1]}}dk</div>
                                        <div class="flight-type-icon"><img src="../assets/images/flight-line.png"></div>
                                        <div class="flight-type d-none">{{item.length>1?'Aktarmalı':'Direkt'}}</div>
                                        <div class="flight-air-code d-none">({{item.origin_code}} - {{item.destination_code}})</div>
                                    </div>
                                    <div class="col-1 d-none d-md-block d-lg-block text-right">
                                        <img src="../assets/images/inis-wh.png" />
                                    </div>
                                    <div class="col-6 col-md-3 pl-0">
                                        <div class="hour">{{item.arrival_time}} {{item.destination_code}}</div>
                                        <div class="airport-name">{{item.arrival_day | moment("Do MMMM YYYY, dddd ")}}</div>
                                        <div class="airport-name">{{item.destination_name}}</div>
                                    </div>
                                    <div class="col-12 d-block d-md-none d-lg-none mt-3">
                                        <div class="flight-time">{{item.duration.split(":")[0]}}sa {{item.duration.split(":")[1]}}dk</div>
                                        <div class="flight-type-icon d-none"><img src="../assets/images/aktarma.png"></div>
                                        <div class="flight-type d-none">{{item.length>1?'Aktarmalı':'Direkt'}}</div>
                                        <div class="flight-air-code d-none">({{item.origin_code}} - {{item.destination_code}})</div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>

                            <div v-if="toDate!=='null'">
                                <div class="title">DÖNÜŞ</div>
                                <div v-for="group in sirala">
                                    <div v-for="(item,index) in group"
                                         v-if="item.od_destination_code == allocate.segments[allocate.segments.length-1].od_destination_code"
                                         :key="index" class="mb-2 pb-2 ">
                                        <div class="flight-info">
                                            <div class="row">
                                                <div class="col-2 col-md-1">
                                                    <img :src="createFlyLogo(item.operating_airline_code)" class="fly-logo">

                                                </div>
                                                <div class="col-10 col-md-11">
                                                    <span class="flight-name d-block d-md-inline-block">
                                                        {{item.operating_airline_name}} {{item.flight_number}} {{flightClass}} / {{item.booking_class}}
                                                    </span>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="ucus-bilgi pl-3 pl-md-0">
                                        <div class="row">
                                            <div class="col-1 d-none d-md-block d-lg-block text-right">
                                                <img src="../assets/images/Kalkis-wh.png" />

                                            </div>
                                            <div class="col-6 col-md-3 p-md-0">
                                                <div class="hour">{{item.departure_time}} {{item.origin_code}}</div>
                                                <div class="airport-name">{{item.departure_day | moment("Do MMMM YYYY, dddd ")}}</div>
                                                <div class="airport-name">{{item.origin_name}}</div>
                                            </div>
                                            <div class="col-4 d-none d-md-block d-lg-block pl-0 text-center">
                                                <div class="flight-time">{{item.duration.split(":")[0]}}sa {{item.duration.split(":")[1]}}dk</div>
                                                <div class="flight-type-icon"><img src="../assets/images/aktarma.png"></div>
                                                <div class="flight-type d-none">Aktarmalı</div>
                                                <div class="flight-air-code d-none">({{item.origin_code}} - {{item.destination_code}})</div>
                                            </div>
                                            <div class="col-1 d-none d-md-block d-lg-block text-right">
                                                <img src="../assets/images/inis-wh.png" />
                                            </div>
                                            <div class="col-6 col-md-3 pl-0">
                                                <div class="hour">{{item.arrival_time}} {{item.destination_code}}</div>
                                                <div class="airport-name">{{item.arrival_day | moment("Do MMMM YYYY, dddd ")}}</div>
                                                <div class="airport-name">{{item.destination_name}}</div>
                                            </div>
                                            <div class="col-12 d-block d-md-none d-lg-none mt-3">
                                                <div class="flight-time">{{item.duration.split(":")[0]}}sa {{item.duration.split(":")[1]}}dk</div>
                                                <div class="flight-type-icon d-none"><img src="../assets/images/flight-line.png"></div>
                                                <div class="flight-type d-none">Aktarmalı</div>
                                                <div class="flight-air-code d-none">({{item.origin_code}} - {{item.destination_code}})</div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </section>
                    <section id="reservation-price-info" class="reservation-flight pt-2" >
                        <div class="p-2 mb-4" style="background-color: #3399d4; border-radius: 6px">
                            <h3 class="text-white" style="font-weight: 300">Fiyat Bilgileri (Taksit detayları ödeme bilgileri alanında gösterilmektedir) </h3>
                        </div>

                        <div class="">
                            <mdb-card class="rez-card">
                                <mdb-card-body>
                                    <div class="row">
                                        <div class="col-6 col-md-3">
                                            <h5>Yolcu</h5>
                                        </div>
                                        <div class="col-6 col-md-3">
                                            <h5>Fiyat</h5>
                                        </div>
                                        <div class="col-6 col-md-3">
                                            <h5>Vergi, Harç, Komisyon</h5>
                                        </div>
                                        <div class="col-6 col-md-3">
                                            <h5>Toplam</h5>
                                        </div>
                                    </div>
                                    <div class="row" v-for="booking_item in allocate.booking_items">
                                        <div class="col-12 col-md-3">{{booking_item.pax_reference.local_pax_type==="ADT"?"Yetişkin":booking_item.pax_reference.local_pax_type==="CHD"?"Çocuk":"Bebek"}}</div>
                                        <div class="col-4 col-md-3">{{booking_item.base_fare}}₺</div>
                                        <div class="col-4 col-md-3">{{parseFloat(parseFloat(booking_item.taxes) + parseFloat(booking_item.service_fee)).toFixed(2)}}₺</div>
                                        <div class="col-4 col-md-3 text-red">{{booking_item.total_fare}}₺</div>
                                        <div class="col-12">
                                            <hr class="d-md-none" />
                                        </div>

                                    </div>

                                    <div class="row" v-for="booking_item in allocateiki.booking_items" v-if="allocateiki">
                                        <div class="col-12 col-md-3">{{booking_item.pax_reference.local_pax_type==="ADT"?"Yetişkin":booking_item.pax_reference.local_pax_type==="CHD"?"Çocuk":"Bebek"}}</div>
                                        <div class="col-4 col-md-3">{{booking_item.base_fare}}₺</div>
                                        <div class="col-4 col-md-3">{{parseFloat(parseFloat(booking_item.taxes) + parseFloat(booking_item.service_fee)).toFixed(2)}}₺</div>
                                        <div class="col-4 col-md-3 text-red">{{booking_item.total_fare}}₺</div>
                                    </div>

                                </mdb-card-body>
                            </mdb-card>
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 col-md-8">
                                        <h4 class="text-red mt-3">
                                            Kazanacağın Puan : +{{(parseInt(totalFare.replace(',',''))*10/100).toFixed()}} Puan
                                        </h4>

                                    </div>
                                    <div class="col-12 col-md-4 p-2 pt-3 text-right" style="background-color: #3399d4;border-radius: 6px">
                                        <h5><span style="color: white">Toplam Ücret:</span> <b>{{totalFare}} TL</b></h5>
                                    </div>
                                </div>
                                <div class="pt-4">
                                    *Biletbul.com'da Puan kazanıp çok daha ucuza bilet satın almak için üye ol.
                                    Eğer üye isen giriş yapıp bilet aldıkça puan kazan. Dikkatini çekmek istiyoruz:
                                    Bu işlemden kazanılan puanlar uçuştan sonraki gün kullanılabilir duruma gelir.
                                </div>
                            </div>

                        </div>
                    </section>
                    <section id="reservation-person-info" class="reservation-flight pt-2">
                        <div class="p-2" style="background-color: #3399d4; border-radius: 6px">
                            <h3 class="text-white" style="font-weight: 300">Yolcu Bilgileri </h3>
                        </div>

                        <div class="">

                            <div class="">
                                <div v-if="alert_info.first_name || alert_info.last_name || alert_info.citizen_no || alert_info.birth_date || alert_info.birth_month || alert_info.passport_no || alert_info.passport_valid_date" class="alert alert-danger mt-2">
                                    <h5><mdb-icon icon="exclamation" /> Lütfen gerekli alanları doldurunuz.</h5>
                                    <small v-if="alert_info.gender">Lütfen Cinsiyet alanını doldurunuz.<br/></small>
                                    <small v-if="alert_info.first_name">Lütfen Ad alanını doldurunuz.<br/></small>
                                    <small v-if="alert_info.last_name">Lütfen Soyad alanını doldurunuz.<br/></small>
                                    <small v-if="alert_info.citizen_no">Lütfen T.C Kimlik alanını doldurunuz.<br/></small>
                                    <small v-if="alert_info.birth_date || alert_info.birth_month">Lütfen Doğum tarihi alanını doldurunuz.<br/></small>
                                    <small v-if="alert_info.passport_no || alert_info.passport_no">Lütfen Pasaport numarası alanını doldurunuz.<br/></small>
                                    <small v-if="alert_info.passport_valid_date || alert_info.passport_valid_date">Lütfen Pasaport tarih alanını doldurunuz.<br/></small>
                                </div>
                                <div class="d-none">
                                    {{numitems = 0}}
                                </div>
                                <div v-for="index in parseInt(adult)" :key="index" >
                                    <div class="flight-info">
                                        <label class="text-muted">{{index}}. Yetişkin Yolcu</label>
                                    </div>
                                    <div class="mb-2 p-2" :class="{'even ': index % 2 === 0, 'even': index % 2 !== 0 }" style="border-radius: 6px">
                                        <div class="row">
                                            <div class="col-12 mb-3">

                                                <!-- Group of default radios - option 1 -->
                                                <span style="display: none"> {{persons[(index-1)]['type'] = 'ADT'}}</span>
                                                <span style="display: none"> {{persons[(index-1)]['pax_reference_id'] = allocate.booking_items[(index-1)].pax_reference.pax_reference_id}}</span>
                                                <span style="display: none"> {{persons[(index-1)]['sequence_no'] = allocate.booking_items[(index-1)].pax_reference.local_sequence_no}}</span>
                                                <input type="hidden" :name="'type'+index" v-model="persons[(index-1)]['type']">
                                            </div>
                                            <div class="col-12 col-md-3" >
                                                <div class="row">
                                                    <div class="col-6 col-md-6">
                                                        <div class="custom-control custom-radio">
                                                            <input type="radio" class="custom-control-input" :id="'male'+index" :name="'gender'+index" v-model="persons[(index-1)]['gender']" value="M">
                                                            <label class="custom-control-label" :for="'male'+index">Erkek</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 col-md-6">
                                                        <!-- Group of default radios - option 2 -->
                                                        <div class="custom-control custom-radio">
                                                            <input ref="first_name" type="radio" class="custom-control-input" :id="'female'+index" :name="'gender'+index"
                                                                   v-model="persons[(index-1)]['gender']" value="F">
                                                            <label class="custom-control-label" :for="'female'+index">Kadın</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 mb-4">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input type="checkbox" class="custom-control-input" :id="'tc-citizen'+index"
                                                           true-value="TR" false-value=""
                                                           v-model="persons[(index-1)]['nationality']" value="TR">
                                                    <label class="custom-control-label" :for="'tc-citizen'+index">Türk vatandaşı</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'name'+index">Ad *</label>
                                                    <input type="text" :id="'name'+index" class="form-control" name="first_name[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['first_name']" :class="{'is-invalid':hasError == 'name'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Ad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'surename'+index">Soyad *</label>
                                                    <input type="text" :id="'surename'+index" class="form-control" name="last_name[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['last_name']" :class="{'is-invalid':hasError == 'surename'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Soyad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'birthdate'+index">Doğum Tarihi *</label>
                                                    <input type="text" :id="'birthdate'+index" class="form-control" name="birth_date[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'birthdate'+index || hasError=='All'}"
                                                           v-model="persons[(index-1)]['birth_datef']" v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Doğum tarihini doğru formatta giriniz</div>
                                                    <!--<datepicker :readonly=false class="form-control" name="birth_date[]" v-model="persons[(index-1)]['birth_date']"
                                                                :format="customFormatter" :language="tr" :disabledDates="disabledAdultDates" :initialView="'year'"
                                                    ></datepicker>-->
                                                </div>
                                            </div>
                                            <div class="col-12" :class="persons[(index-1)]['nationality'] === 'TR' ? 'col-md-3' : 'col-md-6'" v-if="(toCountry==='TR' && fromCountry == 'TR')">
                                                <div class="form-group" v-if="persons[(index-1)]['nationality'] === 'TR'">
                                                    <label :for="'tcno'+index">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+index" class="form-control" name="citizen_no[]" @blur="handleBlur" maxlength="11" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['citizen_no']" :class="{'is-invalid':hasError == 'tcno'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                                <div v-else style="display: inline-flex;gap: 30px;">
                                                  <div class="form-group">
                                                    <label :for="'ppno'+index">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+index" class="form-control" name="passport_no[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['passport_no']" :class="{'is-invalid':hasError == 'ppno'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[(index-1)]['passport_country']">
                                                  </div>
                                                  <div class="form-group">
                                                    <label :for="'ppdate'+index">Pasaport Date *</label>
                                                    <input type="text" :id="'ppdate'+index" class="form-control" name="passport_valid_date[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['passport_valid_date']" :class="{'is-invalid':hasError == 'ppdate'+index || hasError=='All'}" v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Pasaport tarihini giriniz</div>
                                                  </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3" v-if="(toCountry !== 'TR' || fromCountry !== 'TR') && persons[(index-1)]['nationality'] === 'TR'">
                                                <div class="form-group">
                                                    <label :for="'tcno'+index">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+index" class="form-control" name="citizen_no[]" @blur="handleBlur" maxlength="11" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['citizen_no']" :class="{'is-invalid':hasError == 'tcno'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3" v-if="(toCountry !== 'TR' || fromCountry !== 'TR')">
                                                <div class="form-group">
                                                    <label :for="'ppno'+index">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+index" class="form-control" name="passport_no[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['passport_no']" :class="{'is-invalid':hasError == 'ppno'+index || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[(index-1)]['passport_country']">
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3" v-if="(toCountry !== 'TR' || fromCountry !== 'TR')">
                                              <div class="form-group">
                                                  <label :for="'ppdate'+index">Pasaport Date *</label>
                                                  <input type="text" :id="'ppdate'+index" class="form-control" name="passport_valid_date[]" @blur="handleBlur" :tabindex="numitems +=1"
                                                         v-model="persons[(index-1)]['passport_valid_date']" :class="{'is-invalid':hasError == 'ppdate'+index || hasError=='All'}"  v-mask="'##/##/####'" placeholder="--/--/----">
                                                  <div class="invalid-feedback">Lütfen Pasaport tarihi giriniz</div>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="form-group">
                                                    <label :for="'miles_id'+index">Miles And Smiles no</label>
                                                    <input :id="'miles_id'+index" type="text" class="form-control" placeholder="" :tabindex="numitems +=1"
                                                           v-model="persons[(index-1)]['miles_id']">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div  v-if="child>0" v-for="indexchd in parseInt(child)" :key="indexchd" >
                                    <div class="flight-info">
                                        <label class="text-muted">{{indexchd}}. Çocuk Yolcu</label>
                                    </div>
                                    <div class="mb-2 p-2" :class="{'even ': index % 2 === 0, 'even': index % 2 !== 0 }" style="border-radius: 6px">
                                        <div class="row">
                                            <div class="col-12 mb-3" >

                                                <!-- Group of default radios - option 1 -->
                                                <span style="display: none"> {{persons[((parseInt(adult)+indexchd)-1)]['type'] = 'CHD'}}</span>
                                                <span style="display: none"> {{persons[((parseInt(adult)+indexchd)-1)]['pax_reference_id'] = allocate.booking_items[((parseInt(adult)+indexchd)-1)].pax_reference.pax_reference_id}}</span>
                                                <span style="display: none"> {{persons[((parseInt(adult)+indexchd)-1)]['sequence_no'] = allocate.booking_items[((parseInt(adult)+indexchd)-1)].pax_reference.local_sequence_no}}</span>

                                                <input type="hidden" :name="'type'+(parseInt(adult)+indexchd)" v-model="persons[((parseInt(adult)+indexchd)-1)]['type']">
                                            </div>

                                            <div class="col-12 col-md-3">
                                                <div class="row">
                                                    <div class="col-6 col-md-6">
                                                        <div class="custom-control custom-radio">
                                                            <input type="radio" class="custom-control-input" :id="'male'+(parseInt(adult)+indexchd)"
                                                                   :name="'gender'+(parseInt(adult)+indexchd)" v-model="persons[((parseInt(adult)+indexchd)-1)]['gender']" value="M">
                                                            <label class="custom-control-label" :for="'male'+(parseInt(adult)+indexchd)">Erkek</label>
                                                        </div>
                                                            </div>
                                                            <div class="col-6 col-md-6">
                                                        <!-- Group of default radios - option 2 -->
                                                        <div class="custom-control custom-radio">
                                                            <input type="radio" class="custom-control-input" :id="'female'+(parseInt(adult)+indexchd)"
                                                                   :name="'gender'+(parseInt(adult)+indexchd)" v-model="persons[(parseInt(adult)+indexchd-1)]['gender']" value="F">
                                                            <label class="custom-control-label" :for="'female'+(parseInt(adult)+indexchd)">Kadın</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 mb-4">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input type="checkbox" class="custom-control-input" :id="'tc-citizen'+(parseInt(adult)+indexchd)"
                                                           true-value="TR" false-value=""
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['nationality']" value="TR">
                                                    <label class="custom-control-label" :for="'tc-citizen'+(parseInt(adult)+indexchd)">Türk vatandaşı</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'name'+(parseInt(adult)+indexchd)">Ad *</label>
                                                    <input type="text" :id="'name'+(parseInt(adult)+indexchd)" class="form-control" name="first_name[]" @blur="handleBlur"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['first_name']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'name'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Ad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'surename'+(parseInt(adult)+indexchd)">Soyad *</label>
                                                    <input type="text" :id="'surename'+(parseInt(adult)+indexchd)" class="form-control" name="last_name[]" @blur="handleBlur"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['last_name']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'surename'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Soyad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'birthdate'+(parseInt(adult)+indexchd)">Doğum Tarihi *</label>
                                                    <input type="text" :id="'birthdate'+(parseInt(adult)+indexchd)" class="form-control" @blur="handleBlur"
                                                           name="birth_date[]" v-model="persons[(parseInt(adult)+indexchd-1)]['birth_datef']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'birthdate'+(parseInt(adult)+indexchd) || hasError=='All'}"
                                                           v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Doğum tarihini doğru formatta giriniz</div>
                                                    <!--datepicker class="form-control" name="birth_date[]" v-model="persons[(parseInt(adult)+indexchd-1)]['birth_date']"
                                                                :format="customFormatter" :language="tr" :disabledDates="disabledChildDates" :initialView="'year'"
                                                    ></datepicker-->
                                                </div>
                                            </div>
                                            <div class="col-12" :class="persons[(parseInt(adult)+indexchd-1)]['nationality'] ==='TR' ? 'col-md-3' : 'col-md-6'" v-if="(toCountry==='TR' && fromCountry == 'TR')">
                                                <div class="form-group" v-if="persons[(parseInt(adult)+indexchd-1)]['nationality']==='TR'">
                                                    <label :for="'tcno'+(parseInt(adult)+indexchd)">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+(parseInt(adult)+indexchd)" class="form-control"
                                                           name="citizen_no[]" @blur="handleBlur" maxlength="11" :tabindex="numitems +=1"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['citizen_no']"
                                                           :class="{'is-invalid':hasError == 'tcno'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                                <div v-else style="display: inline-flex; gap: 30px;">
                                                  <div class="form-group">
                                                    <label :for="'ppno'+(parseInt(adult)+indexchd)">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+(parseInt(adult)+indexchd)" class="form-control" :tabindex="numitems +=1"
                                                           name="passport_no[]" @blur="handleBlur" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_no']"
                                                           :class="{'is-invalid':hasError == 'ppno'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_country']">
                                                  </div>
                                                  <div class="form-group">
                                                    <label :for="'ppdate'+(parseInt(adult)+indexchd)">Pasaport Date *</label>
                                                    <input type="text" :id="'ppdate'+(parseInt(adult)+indexchd)" class="form-control" :tabindex="numitems +=1"
                                                           name="passport_valid_date[]" @blur="handleBlur" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_valid_date']"
                                                           :class="{'is-invalid':hasError == 'ppdate'+(parseInt(adult)+indexchd) || hasError=='All'}" v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Pasaport tarihini giriniz</div>
                                                  </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3" v-if="(toCountry!=='TR' || fromCountry !=='TR') && persons[(parseInt(adult)+indexchd-1)]['nationality']==='TR'">
                                                <div class="form-group" v-if="persons[(parseInt(adult)+indexchd-1)]['nationality']==='TR'">
                                                    <label :for="'tcno'+(parseInt(adult)+indexchd)">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+(parseInt(adult)+indexchd)" class="form-control"
                                                           name="citizen_no[]" @blur="handleBlur" maxlength="11" :tabindex="numitems +=1"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['citizen_no']"
                                                           :class="{'is-invalid':hasError == 'tcno'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3" v-if="(toCountry!=='TR' || fromCountry !=='TR')">
                                                <div class="form-group">
                                                    <label :for="'ppno'+(parseInt(adult)+indexchd)">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+(parseInt(adult)+indexchd)" class="form-control" :tabindex="numitems +=1"
                                                           name="passport_no[]" @blur="handleBlur" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_no']"
                                                           :class="{'is-invalid':hasError == 'ppno'+(parseInt(adult)+indexchd) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_country']">
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3" v-if="(toCountry!=='TR' || fromCountry !=='TR')">
                                                <div class="form-group">
                                                    <label :for="'ppdate'+(parseInt(adult)+indexchd)">Pasaport Date *</label>
                                                    <input type="text" :id="'ppdate'+(parseInt(adult)+indexchd)" class="form-control" :tabindex="numitems +=1"
                                                           name="passport_valid_date[]" @blur="handleBlur" v-model="persons[(parseInt(adult)+indexchd-1)]['passport_valid_date']"
                                                           :class="{'is-invalid':hasError == 'ppdate'+(parseInt(adult)+indexchd) || hasError=='All'}" v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Pasaport tarihini giriniz</div>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-3">
                                                <div class="form-group">
                                                    <label :for="'miles_id'+(parseInt(adult)+indexchd)">Miles And Smiles no</label>
                                                    <input type="text" class="form-control" :id="'miles_id'+(parseInt(adult)+indexchd)"
                                                           v-model="persons[(parseInt(adult)+indexchd-1)]['miles_id']">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div  v-if="infant>0" v-for="indexinf in parseInt(infant)" >
                                    <div class="flight-info">
                                        <label class="text-muted">{{indexinf}}. Bebek Yolcu</label>
                                    </div>
                                    <div class="mb-2 p-2" :class="{'even ': index % 2 === 0, 'even': index % 2 !== 0 }" style="border-radius: 6px">
                                        <div class="row">
                                            <div class="col-12 mb-3" >
                                                <!-- Group of default radios - option 1 -->
                                                <span style="display: none"> {{persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['type'] = 'INF'}}</span>
                                                <span style="display: none"> {{persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['pax_reference_id'] = allocate.booking_items[((parseInt(adult)+parseInt(child)+indexinf)-1)].pax_reference.pax_reference_id}}</span>
                                                <span style="display: none"> {{persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['sequence_no'] = allocate.booking_items[((parseInt(adult)+parseInt(child)+indexinf)-1)].pax_reference.local_sequence_no}}</span>

                                                <input type="hidden" :name="'type'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                       v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['type']">

                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="row">
                                                    <div class="col-6 col-md-6">
                                                        <div class="custom-control custom-radio">
                                                            <input type="radio" class="custom-control-input" :id="'male'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                                   name="gender[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['gender']" value="M">
                                                            <label class="custom-control-label" :for="'male'+(parseInt(adult)+parseInt(child)+indexinf)">Erkek</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 col-md-6">
                                                        <!-- Group of default radios - option 2 -->
                                                        <div class="custom-control custom-radio">
                                                            <input type="radio" class="custom-control-input" :id="'female'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                                    name="gender[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['gender']" value="F">
                                                            <label class="custom-control-label" :for="'female'+(parseInt(adult)+parseInt(child)+indexinf)">Kadın</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 mb-4">
                                                <div class="custom-control custom-checkbox custom-control-inline">
                                                    <input type="checkbox" class="custom-control-input" :id="'tc-citizen'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                           true-value="TR" false-value=""
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['nationality']" value="TR">
                                                    <label class="custom-control-label" :for="'tc-citizen'+(parseInt(adult)+parseInt(child)+indexinf)">Türk vatandaşı</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'name'+(parseInt(adult)+parseInt(child)+indexinf)">Ad *</label>
                                                    <input type="text" :id="'name'+(parseInt(adult)+parseInt(child)+indexinf)" class="form-control"
                                                           @blur="handleBlur"
                                                           name="first_name[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['first_name']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'name'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Ad giriniz</div>
                                                </div>

                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'surename'+(parseInt(adult)+parseInt(child)+indexinf)">Soyad *</label>
                                                    <input type="text" :id="'surename'+(parseInt(adult)+parseInt(child)+indexinf)"
                                                           class="form-control" @blur="handleBlur" :tabindex="numitems +=1"
                                                           name="last_name[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['last_name']"
                                                           :class="{'is-invalid':hasError == 'surename'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Soyad giriniz</div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label :for="'birthdate'+(parseInt(adult)+parseInt(child)+indexinf)">Doğum Tarihi *</label>
                                                    <input type="text" :id="'birthdate'+(parseInt(adult)+parseInt(child)+indexinf)" class="form-control" name="birth_date[]"
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['birth_datef']" @blur="handleBlur"
                                                           :class="{'is-invalid':hasError == 'birthdate'+(parseInt(adult)+indexinf) || hasError=='All'}" :tabindex="numitems +=1"
                                                           v-mask="'##/##/####'" placeholder="--/--/----">
                                                    <div class="invalid-feedback">Lütfen Doğum tarihini doğru formatta giriniz</div>
                                                    <!--datepicker class="form-control" name="birth_date[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['birth_date']"
                                                                :format="customFormatter" :language="tr"  :disabledDates="disabledBabeDates" :initialView="'year'"
                                                    ></datepicker-->

                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="form-group" v-if="(toCountry==='TR' && fromCountry == 'TR')">
                                                    <label :for="'tcno'+(parseInt(adult)+parseInt(child)+indexinf)">T.C. Kimlik No *</label>
                                                    <input type="text" :id="'tcno'+(parseInt(adult)+parseInt(child)+indexinf)" :tabindex="numitems +=1"
                                                           class="form-control" @blur="handleBlur" name="citizen_no[]" maxlength="11"
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['citizen_no']"
                                                           :class="{'is-invalid':hasError == 'tcno'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen T.C. Kimlik numaranızı giriniz</div>
                                                </div>
                                                <div class="form-group" v-else>
                                                    <label :for="'ppno'+(parseInt(adult)+parseInt(child)+indexinf)">Pasaport No *</label>
                                                    <input type="text" :id="'ppno'+(parseInt(adult)+parseInt(child)+indexinf)" class="form-control" name="passport_no[]"
                                                           @blur="handleBlur" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['passport_no']" :tabindex="numitems +=1"
                                                           :class="{'is-invalid':hasError == 'ppno'+(parseInt(adult)+parseInt(child)+indexinf) || hasError=='All'}">
                                                    <div class="invalid-feedback">Lütfen Pasaport numaranızı giriniz</div>
                                                    <input type="hidden" name="passport_country[]" v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['passport_country']">
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="form-group">
                                                    <label :for="'miles_id'+index">Miles And Smiles no</label>
                                                    <input type="text" class="form-control " placeholder=""
                                                           v-model="persons[((parseInt(adult)+parseInt(child)+indexinf)-1)]['miles_id']">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                    <section id="reservation-user" class="reservation-flight pt-2">
                        <div class="p-2" style="background-color: #3399d4; border-radius: 6px">
                            <h3 class="text-white" style="font-weight: 300">İletişim Bilgileri </h3>
                        </div>
                        <div class="">
                            <mdb-card>
                                <mdb-card-body style="background-color: #ebeef1; border-radius: 6px">
                                    <div class="row">
                                        <div class="col-12 col-md-4 pr-md-1">
                                            <div class="form-group">
                                                <label for="email">E-Posta *</label>
                                                <input type="email" id="email" class="form-control" v-model="contact_email"
                                                       @blur="handleBlur" :class="{'is-invalid':hasError == 'email' || hasError=='All'}" name="user_email">
                                                <div class="invalid-feedback">Lütfen E-mail adresini giriniz</div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-2 px-md-2 pr-md-0">
                                            <div class="form-group">
                                                <label for="phone-number">Gsm No</label>
                                                <input type="text" id="phone-number" class="form-control" required v-mask="'5## ### ## ##'"
                                                       placeholder="5__ ___ __ __" name="contact_phone" v-model="contact_phone"
                                                       @blur="handleBlur" :class="{'is-invalid':hasError == 'phone-number' || hasError=='All'}" >
                                                <div class="invalid-feedback">Lütfen Cep Telefon numaranızı giriniz</div>
                                                <input type="hidden" id="phone-code" class="form-control" readonly placeholder="+90" name="contact_phone_area" v-model="contact_phone_area" >
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row discount-area">
                                        <div class="col-12 col-md-4 p-md-0">
                                            <div class="form-group">
                                                <input type="text" id="discount-code" class="form-control" placeholder="İndirim Kuponu Kullan">
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <mdb-btn size="sm" color="info">Doğrula</mdb-btn>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="note">Notlar</label>
                                                <textarea id="note" name="note" class="form-control" v-model="note" />
                                            </div>
                                        </div>
                                    </div>
                                    <label class="text-red">
                                        Uçuş bilgileriniz e-postanıza ve cep telefonunuza gönderilecektir.
                                    </label>
                                    <div class="">
                                        <div>
                                            <label>Fırsat ve duyurulardan haberdar olmak;</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input " id="not-allow" v-model="noBulten" @click="acceptBulten = false" value="false" >
                                            <label class="custom-control-label" for="not-allow">İstemiyorum</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="allow-info" v-model="acceptBulten" @click="noBulten = false" value="true" />
                                            <label class="custom-control-label" for="allow-info">İstiyorum</label>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="fatura-want" value="true" v-model="fatura_want" @click="collapse2 === true ? collapse2 = false : collapse2 = true"/>
                                            <label class="custom-control-label" for="fatura-want"> Fatura İstiyorum</label>
                                        </div>
                                    </div>
                                    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave">
                                        <div v-if="collapse2" class="collapse-item mt-2">
                                            <div class="row m-1" style="background-color: aliceblue;padding: 10px;">
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="billing_name">Firma Ünvan/Kişi Adı soyadı </label>
                                                        <input type="text" id="billing_name" class="form-control"
                                                               name="billing_name" v-model="billing_name">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="tax_office">Vergi Dairesi </label>
                                                        <input type="text" id="tax_office" class="form-control"
                                                               name="tax_office" v-model="tax_office">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="tax_number">Vergi/TCK no </label>
                                                        <input type="text" id="tax_number" class="form-control"
                                                               name="tax_number" v-model="tax_number">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <div class="form-group">
                                                        <label for="address_detail">Adres </label>
                                                        <input type="text" id="address_detail" class="form-control"
                                                               name="address_detail" v-model="address_detail">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <label for="zip_code">Posta kodu </label>
                                                        <input type="text" id="zip_code" class="form-control"
                                                               name="zip_code" v-model="zip_code">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <label for="address_district">İlçe </label>
                                                        <input type="text" id="address_district" class="form-control"
                                                               name="address_district" v-model="address_district">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <label for="city">Şehir </label>
                                                        <input type="text" id="city" class="form-control"
                                                               name="city" v-model="city">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                    <div v-if="errorMessage" class="m-3">
                                        <mdb-alert color="danger">
                                            {{errorMessage}}
                                        </mdb-alert>
                                    </div>
                                    <div class="text-right" v-if="!odemeYap">
                                        <button class="btn m-0 btn-info" @click="updatePassengers()" :disabled="disabledButton">Ödeme Adımına İlerle</button>
                                    </div>
                                </mdb-card-body>
                            </mdb-card>
                        </div>
                    </section>
                    <section id="reservation-payment" class="reservation-flight pt-2" v-if="odemeYap">
                        <div class="bg-blue p-2">
                            <h6>Ödeme Bilgileri</h6>
                        </div>
                        <div class="">
                            <mdb-card>
                                <mdb-card-body>
                                    <div class="row">
                                        <div class="col-12 col-md-6 pr-md-1">
                                            <div class="form-group">
                                                <label for="holder-name">Kartın Üzerindeki Ad-Soyad</label>
                                                <input type="text" id="holder-name" class="form-control" v-model="card_holder">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-6 pr-md-1">
                                            <div class="form-group">
                                                <label for="card-number">Kart Numarası</label>
                                                <input type="text" id="card-number" v-mask="'####-####-####-####'" class="form-control" v-model="card_number">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <label for="card-month">Son Kullanma Tarihi</label>
                                            <div class="row">
                                                <div class="col-6 pr-1">
                                                    <div class="form-group">
                                                        <label for="card-month">Ay</label>
                                                        <input type="text" min="01" max="12" id="card-month" v-mask="'##'" class="form-control" placeholder="_ _" v-model="expiration_month">
                                                    </div>
                                                </div>
                                                <div class="col-6 pr-1">
                                                    <div class="form-group">
                                                        <label for="card-year">Yıl</label>
                                                        <input type="text" id="card-year" v-mask="'##'" class="form-control" placeholder="_ _" v-model="expiration_year">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <label for="card-cvv">Güvenlik Kodu</label>
                                            <div class="row">
                                                <div class="col-6 pr-1">
                                                    <div class="form-group">
                                                        <label for="card-cvv">CVV</label>
                                                        <input type="text" id="card-cvv" v-mask="'###'" class="form-control" placeholder="_ _ _" v-model="cv2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 d-none">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" class="custom-control-input" id="masterCard" name="card_type" v-model="card_type" value="Master">
                                                <label class="custom-control-label" for="masterCard">Master</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input type="radio" class="custom-control-input" id="visaCard" name="card_type" v-model="card_type" value="Visa">
                                                <label class="custom-control-label" for="visaCard">Visa</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 discount-area">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input " id="payment_type" v-model="payment_type" value="1" checked disabled/>
                                            <label class="custom-control-label" for="payment_type"> 3D ile ödeme yapmak istiyorum.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 discount-area">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input " id="accept-rules" checked>
                                            <label class="custom-control-label" for="accept-rules">
                                                <a href="/#/gizlilik-sozlesmesi" target="_blank">
                                                    Acente Kuralları, Bilet Kuralları ve Kişisel Verilerin Korunması ve Gizlilik Politikası nı okudum, kabul ediyorum
                                                </a>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-4">
                                        <div class="row bg-light-gray" style="border-radius: 6px">
                                            <div class="col-12 col-md-8 pl-md-5">
                                                <span style="font-size:20px;color: black">Toplam Ödenecek Tutar:</span>
                                                <span class="total-price pl-4" style="font-size: 30px;font-weight: bold;color: black">{{totalFare}} ₺</span>
                                            </div>
                                            <div class="col-12 col-md-4 text-right pr-md-0">
                                                <button class="btn btn-lg m-0 bg-green" @click="sendPaytoPos" :disabled="satinAl">Satın Al</button>
                                            </div>
                                        </div>
                                    </div>
                                </mdb-card-body>
                            </mdb-card>
                        </div>
                    </section>
                </div>

            </div>
        </div>
        <div class="col-12 d-none d-lg-block col-lg-3 pr-lg-0 ">
            <bb-reservationbar></bb-reservationbar>
        </div>
    </div>

</template>

<script>
    import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbContainer, mdbCol, mdbRow, mdbIcon, mdbView, mdbBtn, mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText,mdbCollapse, mdbStretchedLink, mdbJumbotron,mdbAlert,mdbInput} from 'mdbvue';
    import axios from "axios";
    import format from 'date-fns/format';
    import {en, tr} from 'vuejs-datepicker/dist/locale'
    import Datepicker from 'vuejs-datepicker';
    import * as router from "vue-router";
    import {TheMask} from 'vue-the-mask';
    import reservationBar from '@/components/reservationBar';
    export default {
        name: "searchMain",
        components:{
            mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter,
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbView,
            mdbBtn,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCollapse,
            mdbStretchedLink,
            mdbJumbotron,
            mdbAlert,
            mdbInput,
            Datepicker,
            'bb-reservationbar':reservationBar,
            TheMask
        },
        data() {
            return {
                modal: false,
                en: en,
                tr: tr,
                error_status:false,
                alert_yolcu_bilgileri:false,
                odemeYap: false,
                errorMessage: "",
                collapse2: false,
                return2: false,
                collapse3: false,
                show: true,
                message:'',
                acceptBulten:true,
                noBulten:false,
                window: {
                    width: 0,
                    height: 0
                },
                allocate:[],
                allocateCharter:"",
                allocateCharterArrival:"",
                allocateiki:[],
                sirala:[],
                flightType:localStorage.flight_type,
                fromAir:localStorage.from_code,
                fromIsCity:localStorage.from_is_city,
                fromCity:localStorage.from_city_name,
                fromCountry:localStorage.from_country_code,
                toAir:localStorage.to_code,
                toIsCity:localStorage.to_is_city,
                toCity:localStorage.to_city_name,
                toCountry:localStorage.to_country_code,
                fromDate:localStorage.departure_date,
                toDate:localStorage.return_date,
                adult:localStorage.adult,
                child:localStorage.child,
                infant:localStorage.infant,
                makeBooking : [],
                payPos : [],
                card_holder:"",
                card_number:"",
                expiration_month:"",
                expiration_year:"",
                card_type:"",
                cv2:"",
                payment_type:1,
                totalFare:"",
                sessionid:"",
                disabledButton:true,
                FailUrl:"",
                OkUrl:"",
                Currency:"",
                InstallmentCount:"",
                TxnType:"",
                SecureType:"",
                UserPass:"",
                UserCode:"",
                MerchantID:"",
                Hash:"",
                Rnd:"",
                Lang:"",
                PurchAmount:"",
                OrderId:"",
                MbrId:"",
                departure_charter_id:"",
                arrival_charter_id:"",
                amount_paid:"",
                persons : [
                    {
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },
                    {
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },{
                        type:"",
                        birth_datef: "",
                        citizen_no:"",
                        first_name:"",
                        gender:"",
                        last_name:"",
                        sequence_no:"",
                        pax_reference_id: "",
                        nationality:"TR",
                        passport_country:"TR",
                        passport_no:"",
                        passport_valid_date:"",
                        miles_id:"",
                    },
                ],
                alert_info:[],
                contact_email:"",
                contact_phone_area:"+90",
                contact_phone:"",
                disabledAdultDates:{
                    ranges:[]
                },
                disabledChildDates:{
                    ranges:[]
                },
                disabledBabeDates:{
                    ranges:[]
                },
                hasError:false,
                to_country_code:"",
                flightClass:localStorage.flightClass,
                fatura_want: false,
                billing_name:"",
                tax_office:"",
                tax_number:"",
                address_detail:"",
                zip_code:"",
                address_district:"",
                city:"",
                reservationAll:[],
                ticket_success:false,
                reservationNoApproved:false,
                satinAl:false,
                logoIcon:"",
                note: ""
            };
        },
        methods:{
            createFlyLogo(logo){
                //let images = require.context('../assets/images/Airlines/', false, /\.png$/)
                return require('../assets/images/Airlines/' + logo + ".png");
            },
            beforeEnter(el) {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                if(this.window.width>768){
                    this.elHeight = 300;
                }else{
                    this.elHeight = 645;
                }
            },
            enter(el) {
                el.style.height = this.elHeight+'px';
            },
            beforeLeave(el) {
                el.style.height = 0;
            },
            handleBlur(e) {
                this.hasError = false;
                if(e.target.name === "first_name[]"){
                    if(e.target.value.length<2){
                        this.hasError = e.target.id;
                        this.alert_info.first_name = true;
                        this.alert_yolcu_bilgileri = true;
                    }else{
                        this.alert_info.first_name = false;
                    }
                    if(this.toCountry !== "TR" || this.fromCountry !== "TR"){
                        this.alert_info.citizen_no = false;
                    }
                }
                if(e.target.name === "last_name[]"){
                    if(e.target.value.length<2){
                        this.hasError = e.target.id;
                        this.alert_info.last_name = true;
                        this.alert_yolcu_bilgileri = true;
                    }else{
                        this.alert_info.last_name = false;
                    }
                }
                if(e.target.name === "citizen_no[]"){
                    if(e.target.value.length<11){
                        this.hasError = e.target.id;
                        this.alert_info.citizen_no = true;
                        this.alert_yolcu_bilgileri = true;
                    }else{
                        this.alert_info.citizen_no = false;
                    }
                }

                if(e.target.name === "passport_no[]"){
                    if(e.target.value.length<5){
                        this.hasError = e.target.id;
                        this.alert_info.citizen_no = true;
                        this.alert_yolcu_bilgileri = true;
                    }else{
                        this.alert_info.citizen_no = false;
                    }
                }

                if (e.target.name === "passport_valid_date[]") {
                    if (e.target.value.length == 10 || (this.toCountry === "TR" && this.fromCountry === "TR")) {
                        this.alert_info.passport_valid_date = false;
                    } else {
                      this.hasError = e.target.id;
                      this.alert_info.passport_valid_date = true;
                      this.alert_yolcu_bilgileri = true;
                    }
                }

                if(e.target.name === "user_email"){
                    if(e.target.value.length<2){
                        this.hasError = e.target.id;
                        this.alert_info.user_email = true;
                        this.alert_yolcu_bilgileri = true;
                    }else{
                        this.alert_info.user_email = false;
                    }
                }
                if(e.target.name === "contact_phone"){
                    if(e.target.value.length<10){
                        this.hasError = e.target.id;
                        this.alert_info.contact_phone = true;
                        this.alert_yolcu_bilgileri = true;
                    }else{
                        this.alert_info.contact_phone = false;
                    }
                }
                if(e.target.name === "birth_date[]"){

                    let dateParca = e.target.value.split('/');

                    if(dateParca[0]>31 || dateParca[0]==="00" || dateParca.length === 1){
                        this.hasError = e.target.id;
                        this.alert_yolcu_bilgileri = true;
                        this.alert_info.birth_date = true;
                    }else{
                        this.alert_info.birth_date = false;
                    }
                    if(dateParca[1]>12 || dateParca[1]==="00"){
                        this.hasError = e.target.id;
                        this.alert_yolcu_bilgileri = true;
                        this.alert_info.birth_month = true;
                    }else{
                        console.log(dateParca);
                        this.alert_info.birth_month = false;
                    }
                }
                if(this.alert_info.birth_month === false && this.alert_info.birth_date === false && this.alert_info.citizen_no === false && this.alert_info.last_name === false && this.alert_info.first_name === false ){
                    this.disabledButton = false;
                } else {
                    this.disabledButton = true;
                }
            },
            adultDateRange(){
                let tzoffset = new Date().getTimezoneOffset() * 60000;
                let today = (new Date(Date.now() - tzoffset));

                let oldToday = new Date(today.getTime());
                //oldToday.setDate(oldToday.getDate()-(365*7));
                today.setDate(today.getDate()-(365*11));

                //today.setMonth(today.getMonth());

                //let max = new Date();
                let obj = {};
                //max.setDate(max.getDate() + 30);
                //let max_date = max;

                obj["from"] = today;//new Date(2020,0,24);
                //obj["to"] = oldToday;

                this.disabledAdultDates["ranges"].push(obj);
                this.disabledAdultDates["from"] = today;
                //this.disabledAdultDates["to"] = obj["to"];
                //console.log("disableDates is ");
                //console.log(this.disabledDates);
                //this.booking_date = Date.parse(today);
            },
            childDateRange(){
                let tzoffset = new Date().getTimezoneOffset() * 60000;
                let today = (new Date(Date.now() - tzoffset));

                let oldToday = new Date(today.getTime());
                oldToday.setDate(oldToday.getDate()-(365*11));
                today.setDate(oldToday.getDate()-(365*2));

                //today.setMonth(today.getMonth());

                //let max = new Date();
                let obj = {};
                //max.setDate(max.getDate() + 30);
                //let max_date = max;

                obj["from"] = today;//new Date(2020,0,24);
                obj["to"] = oldToday;

                this.disabledChildDates["ranges"].push(obj);
                this.disabledChildDates["from"] = today;
                this.disabledChildDates["to"] = obj["to"];
                //console.log("disableDates is ");
                //console.log(this.disabledDates);
                //this.booking_date = Date.parse(today);
            },
            babeDateRange(){
                let tzoffset = new Date().getTimezoneOffset() * 60000;
                let today = (new Date(Date.now() - tzoffset));

                let oldToday = new Date(today.getTime());
                oldToday.setDate(oldToday.getDate()-(365*2));

                //today.setMonth(today.getMonth());

                //let max = new Date(); // YOU CAN REMOVE THIS MAX VARIABLE I JUST PUT IT FOR YOUR REFRENCE
                let obj = {};
                //max.setDate(max.getDate() + 30);
                //let max_date = max;

                obj["from"] = today;//new Date(2020,0,24); // FOR DISABLING ALL PREVIOUS DATES I PUT THIS IN RANGES ARRAY INSIDE DISABLEDDATES OBJECT
                obj["to"] = oldToday;

                this.disabledBabeDates["ranges"].push(obj);
                this.disabledBabeDates["from"] = today;
                this.disabledBabeDates["to"] = obj["to"];
                //console.log("disableDates is ");
                //console.log(this.disabledDates);
                //this.booking_date = Date.parse(today);
            },
            customFormatter(date) {
                //this.persons.birth_date = format(date, "YYYY-MM-DD");//moment(date).format('YYYY-MM-DD');
                return format(date, "YYYY-MM-DD");//this.persons.birth_date;
            },
            groupBy(array, key){
                const result = {}
                array.forEach(item => {
                    if (!result[item[key]]){
                        result[item[key]] = []
                    }
                    result[item[key]].push(item)
                })
                return result
            },
            allocateCall(){
                this.to_country_code = localStorage.to_country_code;
                this.sessionid=localStorage.sessionId;
                let datas ="";
                if(localStorage.sub_options){
                    datas = {
                        departure_product_id:localStorage.product_id,
                        departure_service_fee:localStorage.dp_service_fee,
                        session_token:localStorage.sessionToken,
                        session_id:localStorage.sessionId,
                        return_product_id:localStorage.rt_product_id,
                        return_service_fee:localStorage.rt_service_fee,
                        sub_options : localStorage.sub_options.split(','),
                        api_token: localStorage.api_token
                    };
                }else if (localStorage.departure_charter_id){
                    datas = {
                        departure_charter_id:localStorage.departure_charter_id,
                        arrival_charter_id:localStorage.return_charter_id,
                        api_token: localStorage.api_token
                    }
                }
                else{
                    datas = {
                        departure_branded_code:localStorage.departure_branded_code,
                        return_branded_code:localStorage.return_branded_code,
                        departure_product_id:localStorage.dp_product_id,
                        departure_service_fee:localStorage.departure_commission,
                        session_token:localStorage.sessionToken,
                        session_id:localStorage.sessionId,
                        return_product_id:localStorage.rt_product_id,
                        return_service_fee:localStorage.return_commission,
                        api_token: localStorage.api_token,
                    };
                }

                var  self =this;
                axios.post("https://www.biletbul.com/backend/public/api/v1/flight/allocate",datas)
                    .then(function (response) {
                        if(response.data.status===false){
                            self.error_status = true;
                            if(response.data.message === "Sisteme giris yapilmamis"){
                                self.message = response.data.message + " Lütfen Bekleyiniz..."
                            }else{
                                self.message = response.data.message + " Lütfen Bekleyiniz Arama sayfasına yönlendiriliyorsunuz...";
                            }
                            setTimeout(function () {
                                self.$router.go(-1);
                            },2500);
                        } else {
                            if (response.data.data.user != null) {
                              self.collapse2 = true;
                              self.fatura_want = true;
                              self.billing_name = response.data.data.user.billing_title;
                              self.tax_number = response.data.data.user.billing_tax_number;
                              self.tax_office = response.data.data.user.billing_tax_office;
                              self.address_detail = response.data.data.user.billing_address;
                              self.zip_code = response.data.data.user.billing_zip_code;
                              self.address_district = response.data.data.user.billing_district;
                              self.city = response.data.data.user.billing_city;
                              self.contact_email = response.data.data.user.email;
                              self.contact_phone = response.data.data.user.phone;
                            }

                            if(localStorage.departure_charter_id){
                                self.totalFare = 0;
                                self.error_status = false;
                                /**gidiş ve dönüş hesap*/
                                if(self.toDate && localStorage.return_charter_id){
                                    let deparTotal,arrivalTotal;
                                    response.data.data.data.filter(function (a,b) {
                                        console.log(a.id +"===" +localStorage.departure_charter_id);
                                        if(a.id == localStorage.departure_charter_id){
                                            self.allocateCharter = response.data.data.data[b];
                                            deparTotal = (parseFloat(a.adult) * self.adult) + (parseFloat(a.adult) * self.child) + (parseFloat(a.baby) * self.infant)
                                        }
                                        if(a.id == localStorage.return_charter_id){
                                            self.allocateCharterArrival = response.data.data.data[b];
                                            arrivalTotal = (parseFloat(a.adult) * self.adult) + (parseFloat(a.adult) * self.child) + (parseFloat(a.baby) * self.infant)
                                        }
                                    });
                                    self.totalFare = parseFloat(parseFloat(deparTotal)+parseFloat(arrivalTotal)).toFixed(2);
                                }else{
                                    self.allocateCharter = response.data.data.data[0];
                                    self.totalFare = parseFloat((parseFloat(self.allocateCharter.adult) * self.adult) + (parseFloat(self.allocateCharter.adult) * self.child) + (parseFloat(self.allocateCharter.baby) * self.infant)).toFixed(2);
                                }
                                self.charterPosHash(self.totalFare);
                            }else{
                                if(response.data.data.data.length>1){
                                    self.totalFare = parseFloat(parseFloat(response.data.data.data[0].total_fare)+parseFloat(response.data.data.data[1].total_fare)).toFixed(2);
                                }else{
                                    self.totalFare = response.data.data.data[0].total_fare;
                                }
                                self.allocate = response.data.data.data[0];
                                self.sirala = self.groupBy(self.allocate.segments, 'od_origin_code');
                                if(response.data.data.data[1]){
                                    self.allocateiki = response.data.data.data[1];
                                }
                            }
                            localStorage.total_fares = self.totalFare;
                        }
                    })
                    .catch(error => {
                        self.error_status = true;
                        //self.$router.go(-1);
                    })
            },
            charterPosHash(amount){
                let self = this;
                axios.post("https://www.biletbul.com/backend/public/api/v1/flight/get_payment_params",{
                    amount:amount,
                })
                    .then(function (response) {
                            self.FailUrl=response.data.data.FailUrl;
                            self.OkUrl=response.data.data.OkUrl;
                            self.Currency=response.data.data.Currency;
                            self.InstallmentCount=response.data.data.InstallmentCount;
                            self.TxnType=response.data.data.TxnType;
                            self.SecureType=response.data.data.SecureType;
                            self.UserPass=response.data.data.UserPass;
                            self.UserCode=response.data.data.UserCode;
                            self.MerchantID=response.data.data.MerchantID;
                            self.Hash=response.data.data.Hash;
                            self.Rnd=response.data.data.Rnd;
                            self.Lang=response.data.data.Lang;
                            self.PurchAmount=response.data.data.PurchAmount;
                            self.OrderId=response.data.data.OrderId;
                            self.MbrId=response.data.data.MbrId;
                    })
            },
            alertErr(va){
                if(va === 'empty'){
                    this.alert_yolcu_bilgileri = true;
                }
            },
            updatePassengersCharter(){
                let self = this;
                this.persons.splice((parseInt(this.adult)+parseInt(this.child)+parseInt(this.infant)), (this.persons.length-(parseInt(this.adult)+parseInt(this.child)+parseInt(this.infant))));
                this.persons.filter(function (e) {
                    if(e.first_name === "" || e.last_name === "" || e.passport_no === "" || e.birth_datef===""){
                        self.alert_yolcu_bilgileri = true;
                        self.hasError = "All";
                    }else {
                        self.hasError = false;
                        self.alert_yolcu_bilgileri = false;
                    }
                    let dateParca = e.birth_datef.split('/');
                    /**
                     * bebek bilet tarihinden önce 0-2,99 yaş
                     * çocuk 3-12,99 yaş
                     * yetişkin 13'den büyük
                     * */
                    return e.birth_date =e.birth_datef.replace(/(..)\/(..)\/(....)/,'$3-$2-$1');
                    //return e.birth_date = format(new Date(e.birth_date), "YYYY-MM-DD");
                });
                if(this.contact_email === "" || this.contact_phone === ""){
                    self.hasError = "All";
                }else {
                    self.hasError = false;
                }

                if (self.hasError === false){
                    localStorage.persons = JSON.stringify(this.persons);
                    localStorage.contact_email = this.contact_email;
                    localStorage.contact_phone = this.contact_phone_area+"-"+this.contact_phone.replace(/ /g,"");
                    localStorage.billing_name = this.billing_name;
                    localStorage.tax_office = this.tax_office;
                    localStorage.tax_number = this.tax_number;
                    localStorage.address_detail = this.address_detail;
                    localStorage.zip_code = this.zip_code;
                    localStorage.address_district = this.address_district;
                    localStorage.city = this.city;
                    localStorage.arrival_charter = JSON.stringify(this.allocateCharterArrival);
                    localStorage.departure_charter = JSON.stringify(this.allocateCharter);
                    localStorage.amount_paid = this.totalFare;
                    this.odemeYap = true;
                }
            },
            updatePassengers(){
                /*if(sonuc!=='true'){
                    console.log("dsa");
                    this.alert_yolcu_bilgileri = true;
                    this.alertErr(sonuc);
                }else{*/
                    this.alert_yolcu_bilgileri=false;
                    var  self =this;

                    this.persons.splice((parseInt(this.adult)+parseInt(this.child)+parseInt(this.infant)), (this.persons.length-(parseInt(this.adult)+parseInt(this.child)+parseInt(this.infant))));

                    this.persons.filter(function (e) {
                        if(e.first_name === "" || e.last_name === "" || e.citizen_no === "" || e.birth_datef===""){
                            self.alert_yolcu_bilgileri = true;
                            self.hasError = "All";

                        }else {
                            self.hasError = false;
                        }

                        if(e.nationality !== 'TR'){}

                        let dateParca = e.birth_datef.split('/');
                        /**
                         * bebek bilet tarihinden önce 0-2,99 yaş
                         * çocuk 3-12,99 yaş
                         * yetişkin 13'den büyük
                         * */
                        return e.birth_date =e.birth_datef.replace(/(..)\/(..)\/(....)/,'$3-$2-$1');
                        //return e.birth_date = format(new Date(e.birth_date), "YYYY-MM-DD");
                    });

                    if(this.contact_email === "" || this.contact_phone === ""){
                        self.hasError = "All";
                    }else {
                        self.hasError = false;
                        self.disabledButton = true;
                    }

                    if(self.hasError === false){
                        axios.post("https://www.biletbul.com/backend/public/api/v1/flight/update_passengers",{
                            session_token:localStorage.sessionToken,
                            session_id:localStorage.sessionId,
                            persons: this.persons,
                            //pax_reference_id:this.allocate.booking_items[0].pax_reference.pax_reference_id,
                            id:this.allocate.id,
                            product_ids:this.allocate.product_ids,
                            contact_email:this.contact_email,
                            contact_phone:this.contact_phone_area+"-"+this.contact_phone.replace(/ /g,""),
                        })
                            .then(function (response) {
                                response.data.data;
                                if(response.data.data.UpdatePassengersResult.HasError == false){
                                    self.makePrebooking();
                                    self.odemeYap = true;
                                }
                            })
                    }
               /* }*/
            },
            makePrebooking(){
                    this.alert_yolcu_bilgileri=false;
                    let  self =this;
                    let toplamServis ="";
                if(this.allocateiki.service_fee>0){
                    //toplamServis = (parseInt(this.allocate.service_fee)+parseInt(this.allocateiki.service_fee));
                    toplamServis = (parseInt(this.allocate.last_seller_commission)+parseInt(this.allocateiki.last_seller_commission));
                }else{
                    //toplamServis = this.allocate.service_fee;
                    toplamServis = this.allocate.last_seller_commission;
                }

                    axios.post("https://www.biletbul.com/backend/public/api/v1/flight/make_prebooking",{
                        session_token:localStorage.sessionToken,
                        session_id:localStorage.sessionId,
                        product_ids:this.allocate.product_ids,//this.allocate.product_ids.length>1?this.allocate.product_ids:[this.allocate.product_ids],
                        departure_branded_code:localStorage.departure_branded_code,
                        departure_product_id:Array.isArray(this.allocate.product_ids.guid)?this.allocate.product_ids.guid[0]:this.allocate.product_ids.guid,
                        service_fee:toplamServis,
                        return_branded_code:localStorage.return_branded_code,
                        return_product_id:localStorage.flight_type==="RT"?Array.isArray(this.allocate.product_ids.guid)?this.allocate.product_ids.guid[1]:this.allocate.product_ids.guid:"",//allocate den gelen product ids parçalanacak...

                    })
                        .then(function (response) {
                            if(response.data.data.MakePrebookingResult.HasError === true){
                                self.odemeYap = false;
                                self.errorMessage = response.data.data.MakePrebookingResult.ServiceError.DebugMessage;
                            }else{
                                self.makeBooking = response.data.data.MakePrebookingResult;
                                localStorage.makeBooking = self.makeBooking.ShoppingFile.Id;
                                self.odemeYap = true;
                            }

                        })
            },
            sendPaytoPos(){
                var self = this;
                self.satinAl=true;
                axios.post("https://www.biletbul.com/backend/public/api/v1/flight/make_payment",{
                    session_token:localStorage.sessionToken,
                    session_id:localStorage.sessionId,
                    billing_name:self.card_holder,
                    card_holder:self.card_holder,
                    card_number:self.card_number.replace(/-/g,""),
                    expiration_month:self.expiration_month,
                    expiration_year:self.expiration_year,
                    card_type:self.card_type,
                    cv2:self.cv2,
                    shopping_file_id:self.makeBooking.ShoppingFile.Id,
                    original_amount:self.makeBooking.ShoppingFile.RemainingSum,
                    amount:self.makeBooking.ShoppingFile.RemainingSum,
                    currency:self.makeBooking.ShoppingFile.Currency,
                    type:1
                })
                .then(function (response) {
                    if(self.payment_type === 1){
                      self.finalizeShoping();
                        if(response.data.data.MakePayment_Init3DPaymentResult){
                            self.payPos =  response.data.data.MakePayment_Init3DPaymentResult;
                            if(self.payPos.HasError === false){

                                /**iframe eklenebilir*/
                                window.location.href = self.payPos.ContinueUrl;
                            }
                        }
                    }else{
                        if(response.data.data.MakePayment_FromCreditCardResult){
                            self.payPos = response.data.data.MakePayment_FromCreditCardResult;
                            if(self.payPos.HasError === false){
                                //self.finalizeShoping();
                                window.location.href = '/#/success';
                            }
                        }
                    }
                })
            },
            finalizeShoping(){
                var self = this;
                axios.post("https://www.biletbul.com/backend/public/api/v1/flight/finalize_shopping",{
                    session_token:localStorage.sessionToken,
                    session_id:localStorage.sessionId,
                    shopping_file_id:self.makeBooking.ShoppingFile.Id,
                    billing_name: self.billing_name,
                    tax_office: self.tax_office,
                    tax_number: self.tax_number,
                    address_detail: self.address_detail,
                    address_zip_code: self.zip_code,
                    address_district: self.address_district,
                    address_city: self.city,
                    note: self.note,
                    api_token: localStorage.api_token
                })
                .then(function (response) {
                    if(response.data.data.FinalizeShoppingResult.HasError === false){
                        self.reservationNoApproved = false;
                        self.ticket_success = true;
                        self.reservationAll = response.data.data.FinalizeShoppingResult.ShoppingFile;
                        window.location.href = '/#/success';
                        //router({ name: 'success', params: { userId: 123 }});
                    }
                });
            },
            testPost() {
                window.location.href = "https://www.biletbul.com/backend/public/api/v1/post";
            }

        },
        watch:{
            fatura_want:function(){
                if(this.fatura_want === true){
                    localStorage.billing_name = this.billing_name;
                    localStorage.tax_office = this.tax_office;
                    localStorage.tax_number = this.tax_number;
                    localStorage.address_detail = this.address_detail;
                    localStorage.zip_code = this.zip_code;
                    localStorage.address_district = this.address_district;
                    localStorage.city = this.city;
                }else{
                    if(localStorage.billing_name){
                        localStorage.removeItem("billing_name");
                        localStorage.removeItem("tax_office");
                        localStorage.removeItem("tax_number");
                        localStorage.removeItem("address_detail");
                        localStorage.removeItem("zip_code");
                        localStorage.removeItem("address_district");
                        localStorage.removeItem("city");
                    }
                }
            },
            card_number:function(){

              if(this.card_number.length === 1){
                  if(this.card_number[0]==="4"){
                      this.card_type = "Visa"
                  }else{
                      this.card_type = "Master"
                  }
                  console.log("num"+this.card_number);
              }

            },
            allocate:function(){
                localStorage.departure_time = this.allocate.segments[0].departure_time;
                localStorage.return_time = this.allocate.segments[this.allocate.segments.length-1].departure_time;
            },
            allocateCharter:function(){
                localStorage.departure_time = this.allocateCharter.departure_hour;
                localStorage.return_time = this.allocateCharter.departure_hour;
            },
        },
        mounted(){
            this.adultDateRange();
            this.childDateRange();
            this.babeDateRange();
            this.allocateCall();

        }
    }
</script>

<style scoped>

</style>
